import _ from 'lodash'
import Wizard from 'scoreboard/components/wizard'
import OrgTemplateDestinationForm from 'scoreboard/organizations/org-template-destination-form'
import DatasetTemplateForm from 'scoreboard/organizations/dataset-template-form'
import TemplateNamingForm from 'scoreboard/templates/template-naming-form'
import i18n from 'scoreboard/components/i18n'

var DATASET_VIEWS = [ OrgTemplateDestinationForm, DatasetTemplateForm, TemplateNamingForm ]
var NON_DATASET_VIEWS = [ OrgTemplateDestinationForm, TemplateNamingForm ]

var TemplateWizard = Wizard.extend({

	initialize: function(options) {
		var opts = _.extend({ views : NON_DATASET_VIEWS }, options)
		Wizard.prototype.initialize.call(this, opts)
	},

	copyType(type) {
		if (type === 'single' || type === 'tree') {
			this.views = NON_DATASET_VIEWS
		} else {
			this.views = DATASET_VIEWS
		}

		this.setProgressValues({
			steps: this.views.length,
			step: 1,
			lastNavigable: 1
		})
	},

	dialogTitle() {
		return i18n.get('template.useHeading',
			'<q>' + _.escape(this.options.model.get('label')) + '</q>')
	}
})

export default TemplateWizard

TemplateWizard.__filename__ = 'organizations/org-template-wizard.js'
